// extracted by mini-css-extract-plugin
export default {"expressCheckoutSection":"Ey-z","expressButtonContainerWithPayPal":"Fy-z","expressButton":"Gy-z","or":"Hy-z"};